var _rect, _path, _path2, _path3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGrantCustomer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 51,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6663 26.5V24.8333C38.6663 23.9493 38.3152 23.1014 37.69 22.4763C37.0649 21.8512 36.2171 21.5 35.333 21.5H28.6663C27.7823 21.5 26.9344 21.8512 26.3093 22.4763C25.6842 23.1014 25.333 23.9493 25.333 24.8333V26.5",
    stroke: "#001236",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 18.1667C33.8413 18.1667 35.3337 16.6743 35.3337 14.8333C35.3337 12.9924 33.8413 11.5 32.0003 11.5C30.1594 11.5 28.667 12.9924 28.667 14.8333C28.667 16.6743 30.1594 18.1667 32.0003 18.1667Z",
    stroke: "#001236",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.64 38.822C30.158 36.078 30.158 34.258 30.158 32.648V31.416H20.792V32.886H28.31C28.31 34.384 28.282 36.176 27.792 38.612L29.64 38.822ZM25.58 40.166V35.728H23.732V40.166H19.616V41.65H31.278V40.166H25.58ZM32.9569 31.206V32.676H36.1489C35.8969 34.412 34.7489 35.714 32.3409 36.596L33.1949 37.94C36.5549 36.638 38.0669 34.468 38.0669 31.206H32.9569ZM34.5389 39.858H41.6229V43.218H43.4709V38.374H34.5389V39.858ZM41.7209 30.31V33.292H40.6149V30.534H38.8929V37.8H40.6149V34.776H41.7209V37.842H43.4709V30.31H41.7209Z",
    fill: "#001236"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 51,
    rx: 1.5,
    stroke: "#001236"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrantCustomer);
export default __webpack_public_path__ + "static/media/icon_grant_customer.9c8a75e0df3a1945a22e31c4d133836f.svg";
export { ForwardRef as ReactComponent };